import type {ViewerData} from '../conversation-types'
import {StatusAvatar} from '@github-ui/status-avatar/StatusAvatar'
import {DotFillIcon} from '@primer/octicons-react'

import styles from './InProgressCommentIndicator.module.css'

export function InProgressCommentIndicator({
  authorAvatarUrl,
  authorLogin,
  lineSpacingPreference,
}: {
  authorAvatarUrl: string
  authorLogin: string
  lineSpacingPreference: ViewerData['lineSpacingPreference']
}) {
  const size = lineSpacingPreference === 'compact' ? 18 : 20

  return (
    <StatusAvatar
      altText={`${authorLogin}'s avatar image with pending indicator`}
      icon={DotFillIcon}
      iconColor="var(--fgColor-attention, var(--color-attention-fg))"
      square={false}
      size={size}
      src={authorAvatarUrl}
      backgroundClassName={styles.statusAvatarBackground}
      className={styles.statusAvatar}
    />
  )
}
